<template>
    <div class="search-top-filter">
        <z-input
            v-model="params.q"
            :placeholder="text.inputPlaceholder"
            is-filter
            @input="onInput"
            :min-length="3"
            ref="input"
            icon="tools/magnifier"
        />
    </div>
</template>

<script setup>
import { debounce } from 'throttle-debounce'
import { ref, onBeforeMount } from 'vue'
import { text } from '../locales'

const props = defineProps({
    initialParams: {
        type: Object,
        default: () => {}
    }
})

const params = ref({
    q: ''
})

const input = ref(null)

const emit = defineEmits([
    'change',
    'clear'
])

const onInput = debounce(500, function () {
    if (input.value.isValid) onFilterChange()
})

const onFilterChange = () => {
    emit('change', params.value)
}

const clear = () => {
    params.value = {
        q: ''
    }
    emit('clear', params.value)
}

defineExpose({
    clear
})

onBeforeMount (() => {
    for (const key in props.initialParams) {
        if (params.value.hasOwnProperty(key)) {
            params.value[key] = props.initialParams[key]
        }
    }
})
</script>

<style lang="scss">
.search-top-filter{
    .z-input__input{
        width: 100%;
        padding-right: 40px;
    }
}
</style>
